module.exports = __webpack_public_path__ + "static/media/vaccine.cb55a561.svg";